export enum CompTypes {
    Subject = 'Subject',
    Sale = 'Sale'
}
